import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import classes from './Header.module.css'
import { ReactComponent as RightIcon } from '../../assets/icons/right.svg'
import { ReactComponent as DownIcon } from '../../assets/icons/down.svg'
import { useHideOnClickOutside } from '../../hooks/useHideOnClickOutside'

export const HeaderDropdown = ({
    title,
    image = null,
    imageOnly = false,
    icon = false,
    listItem = true,
    children,
    className,
    triggerOnClick = false,
    ...props
}) => {
    const [open, setOpen] = useState(false)

    const elementProps = {
        className: classNames(
            classes.headerDropdown,
            listItem && classes.headerDropdownList,
            open && classes.headerDropdownActive,
            className
        ),
        ...props,
    }

    const toggleDropdown = () => setOpen(open => !open)
    const hideDropdown = () => setOpen(false)
    const itemsElRef = useRef(null)

    useHideOnClickOutside({
        el: itemsElRef.current,
        hide: hideDropdown,
        open,
    })

    const content = () => (
        <>
            <button
                className={classes.dropdownTrigger}
                onClick={triggerOnClick && toggleDropdown}
            >
                {!imageOnly && title}
                {image && (
                    <img
                        src={image}
                        alt={title}
                        className={classes.dropdownTriggerImage}
                    />
                )}
                {icon && <DownIcon className={classes.dropdownTriggerIcon} />}
            </button>
            <div ref={itemsElRef} className={classes.dropdownItems}>
                {children}
            </div>
        </>
    )
    return listItem ? (
        <li {...elementProps}>{content()}</li>
    ) : (
        <div {...elementProps}>{content()}</div>
    )
}

export const HeaderDropdownItem = ({
    title,
    url,
    icon = false,
    className,
    ...props
}) => (
    <Link
        to={url}
        className={classNames(classes.dropdownItem, className)}
        {...props}
    >
        {title}
        {icon && <RightIcon className={classes.dropdownItemIcon} />}
    </Link>
)

export const HeaderDropdownButton = ({
    title,
    icon = false,
    className,
    onClick,
    ...props
}) => (
    <button
        className={classNames(
            classes.dropdownItem,
            classes.dropdownButton,
            className
        )}
        {...props}
        onClick={onClick}
    >
        {title}
        {icon && <RightIcon className={classes.dropdownItemIcon} />}
    </button>
)

export const DropdownDivider = ({
    spacing: { top, bottom },
    className,
    ...props
} = {}) => (
    <div
        className={classNames(classes.dropdownDivider, className)}
        style={{
            marginTop: top || 0,
            marginBottom: bottom || 0,
        }}
        {...props}
    />
)
